import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import submitReducer from '../slices/submitSlice';
import { schedulingSlice } from '../slices/schedulingSlice';

export const createStore = () => configureStore({
  reducer: {
    submit: submitReducer,
    scheduling: schedulingSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      // // Ignore these action types:
      // ignoredActions: ['your/action/type'],
      // Ignore these field paths in all actions:
      ignoredActionPaths: ['payload.stepsGraph'],
      // // Ignore these paths in the state:xs
      // ignoredPaths: ['items.dates'],
    },
  }),
});

export const store = createStore();

export type { RootState, AppThunk } from './types';
export type AppDispatch = typeof store.dispatch;
